document.addEventListener('DOMContentLoaded', () => {
  const serviceLinks = {
    'Website Design & Shopify': '/pages/website-design',
    'Website Design & Build': '/pages/website-design',
    'Branding & Identity': '/pages/branding',
    'Product Photography': '/pages/photography',
    'Marketing & Industry PR': '/pages/media',
    'Creative Content': '/pages/creator-lab'
  };

  document.querySelectorAll('.ms-service-title').forEach((title) => {
    const label = title.textContent.trim();
    const href = serviceLinks[label];
    if (!href || title.querySelector('a')) return;

    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    title.textContent = '';
    title.appendChild(link);
  });

  document.querySelectorAll('.mammoth-engagement-cta a, .mammoth-article-journey a, .mpi__link, .ms-cta').forEach((link) => {
    link.addEventListener('click', () => {
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: 'mammoth_cta_click',
        cta_text: link.textContent.trim(),
        cta_url: link.href,
        page_path: window.location.pathname
      });
    });
  });
});
